// src/utils/rolePermissions.js

export const ROLES = {
    SUPER_ADMIN: "SUPER_ADMIN",
    ADMIN: "ADMIN",
    SPONSOR: "SPONSOR",
};

export const rolePermissions = {
    SUPER_ADMIN: [
        "/dashboard",
        "/users",
        "/add-user",
        "/users-grid",
        "/users-list",
        "/enquiry-list",
        "/view-profile",
        "/assign-role",
        "/sessions",
        "/event-locations",
        "/content",
        "/posts",
        "/sessions-type",
        "/notifications",
        "/ratings",
        "/company-category",
        "/sponsors-list",
        "/meetings",
        "/media",
        "/gallery",
        "/floor-maps",
        "/help-desk",
        "/roles",
        "/feedback",
        // "/company-product",
        "/add-management",
        "/conference",
        "/role-access",
        "/active-users",
        "/support",
        "/chat-requests",
        "/chat-conversations",
        "/api-key-generate"
    ],

    ADMIN: [
        "/dashboard",
        "/users",
        "/add-user",
        "/users-grid",
        "/users-list",
        "/enquiry-list",
        "/view-profile",
        "/assign-role",
        "/sessions",
        "/event-locations",
        "/content",
        "/posts",
        "/sessions-type",
        "/notifications",
        "/ratings",
        "/company-category",
        "/sponsors-list",
        "/meetings",
        "/media",
        "/gallery",
        "/floor-maps",
        "/help-desk",
        "/roles",
        "/feedback",
        "/add-management",
        "/conference",
        "/active-users",
        "/support",
        "/chat-requests",
        "/chat-conversations",
    ],

    SPONSOR: [
        "/sponsors",
        "/company-product",
        "/view-profile",
    ],
};
